// Auto-generated by cli-contracts. Do not edit.
import { derivePolicy, isOptionActive } from "./policy-runtime.js";
import type { DerivedPolicy, IntrospectionResult } from "./policy-runtime.js";

export type { DerivedPolicy, IntrospectionResult };

export const commandDefinitions = {
  "compile": {
    "options": [
      {
        "name": "output",
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  "generate": {
    "effects": {},
    "options": [
      {
        "name": "output-dir",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "targets",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "library",
              "cli",
              "runtime",
              "claude",
              "openai"
            ]
          }
        }
      },
      {
        "name": "dry-run",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  "validate": {
    "options": [
      {
        "name": "strict",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  "introspect": {
    "options": [
      {
        "name": "format",
        "schema": {
          "type": "string",
          "enum": [
            "json",
            "yaml"
          ]
        }
      }
    ]
  },
  "init": {
    "effects": {},
    "options": [
      {
        "name": "project-yaml",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "binary-path",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "bootstrap",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "no-llm",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "artifacts-only",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  "update": {
    "effects": {},
    "options": [
      {
        "name": "project-yaml",
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  "uninstall": {
    "effects": {}
  },
  "install": {
    "effects": {},
    "options": [
      {
        "name": "global",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "dry-run",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "skip-cursor",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "skip-claude",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "skip-git",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
} as const;

export function deriveCommandPolicy(
  command_id: string,
  optionValues: Record<string, unknown>,
): IntrospectionResult {
  const def = commandDefinitions[command_id as keyof typeof commandDefinitions];
  if (!def) throw new Error(`Unknown command: ${command_id}`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cmdDef = def as any;
  const options: Record<string, { value: unknown; specified: boolean; definition: any }> = {};
  const active_options: string[] = [];

  for (const optDef of cmdDef.options ?? []) {
    const value = optionValues[optDef.name];
    const specified = optDef.name in optionValues && value !== undefined;
    options[optDef.name] = { value, specified, definition: optDef };
    if (isOptionActive(optDef, value, specified)) {
      active_options.push(optDef.name);
    }
  }

  const policy = derivePolicy({
    command_id,
    command_effects: cmdDef.effects,
    options,
    env: cmdDef.env,
  });

  return { command: command_id, active_options, policy };
}
